<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">Dashboard</router-link>
            <router-link to="/school/reports-and-analytics" class="text-white">
                <i class="fa fa-ellipsis-v mx-2"></i>Reports and Analytics
            </router-link>
            <span class="text-white form-inline"><i class="fa fa-ellipsis-v mx-2"></i>Broad Sheet Per Position <i
                    class="fa fa-arrows-alt-v mx-2"></i> <select v-model="TermType"
                    class="form-control form-control-sm">
                    <option value="1">Full Term</option>
                    <option value="2">Mid Term</option>
                </select></span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <div class="card bg-secondary border-0 mb-0">
                        <div class="card-body">
                            <div class="form-inline">
                                <div class="row">
                                    <div class="col-md-4 pt-3">
                                        <div class="input-group">
                                            <label class="input-group-text">Session</label>
                                            <select v-model="SessionIdval" class="form-control"
                                                @change="getregterm($event)" :disabled="!Sessionitems">
                                                <option value="0" v-if="!Sessionitems">⏳ Loading...</option>
                                                <option value="0" v-else>- Select Session -</option>
                                                <option v-for="item in Sessionitems" :key="item.Id"
                                                    v-bind:value="item.Id">
                                                    {{ item.SchSession }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 pt-3">
                                        <div class="input-group">
                                            <label class="input-group-text">Term</label>
                                            <select v-model="TermIdval" @change="getclass()" class="form-control"
                                                :disabled="!termitems">
                                                <option value="0" v-if="!termitems">⏳ Loading...</option>
                                                <option value="0" v-else>- Select Term -</option>
                                                <option v-for="item in termitems" :key="item.Id" v-bind:value="item.Id">
                                                    {{ item.SchTerm }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 pt-3">
                                        <div class="input-group">
                                            <span class="input-group-text">Class</span>
                                            <select v-model="ClassIdval" class="form-control"
                                                @change="getoption($event)" :disabled="!classitems">
                                                <option value="0" v-if="!classitems">⏳ Loading...</option>
                                                <option value="0" v-else>- Select Class -</option>
                                                <option v-for="item in classitems" :key="item.Id"
                                                    v-bind:value="item.Id">
                                                    {{ item.Sch_Class }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 pt-3">
                                        <div class="input-group">
                                            <span class="input-group-text">Option</span>
                                            <select v-model="OptionIdval" class="form-control" @change="getreport()"
                                                :disabled="!optionitems">
                                                <option value="0" v-if="!optionitems">⏳ Loading...</option>
                                                <option value="0" v-else>- Select Option -</option>
                                                <option v-for="item in optionitems" :key="item.Id"
                                                    v-bind:value="item.Id">
                                                    {{ item.ClassOption }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Report />
                        </div>
                    </div>
                </card>
            </div>

            <!-- End charts-->
        </div>
    </div>
</template>

<script>
import moment from "moment"
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner"
import ValidateAccessToken from "@/mixins/ValidateAccessToken.mixins"
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin"
import Report from "@/components/FileGenerated"

export default {
    name: "Broadsheet",
    mixins: [ValidateAccessToken, CheckStaffUser, Alert],
    components: {
        PageSpinner, Report
    },
    data() {
        return {
            accessDetails: null,
            dataid: 1,
            TermType: 1,
            SessionIdval: "",
            TermIdval: "",
            ClassIdval: "",
            OptionIdval: "",
            Sessionitems: null,
            termitems: null,
            classitems: null,
            optionitems: null,
            report: null,
            currdate: null,
            process: "N",
            onloader: "none",
        };
    },
    methods: {
        getcurendate() {
            var today = new Date();
            this.currdate =
                today.getDate() +
                "/" +
                (today.getMonth() + 1) +
                "/" +
                today.getFullYear();
        },
        printreport() {
            // Get HTML to print from element

            var printContents = document.getElementById("divReport").innerHTML;
            var originalContents = document.body.innerHTML;

            document.body.innerHTML = printContents;

            window.print();

            document.body.innerHTML = originalContents;
        },
        getreport() {
            if (this.OptionIdval > 0) {
                let SessionId = this.SessionIdval;
                let TermId = this.TermIdval;
                let ClassId = this.ClassIdval;
                let OptionId = this.OptionIdval;
                let userdata = {
                    ClassId,
                    OptionId,
                    SessionId,
                    TermId,
                };
                this.onloader = "flex";
                this.$store
                    .dispatch("GetBroadsheetPerPosition", userdata)
                    .then((resp) => {
                        this.onloader = "none";
                        if (resp.responseCode == '00') {
                            this.ShowAlertSuccess(resp.responseMessage, '');
                        } else {
                            this.ShowAlertError(resp.responseMessage, '');
                        }

                    })
                    .catch((err) => {
                        this.onloader = "none";
                        console.log(err);
                    });
            }
        },
        getregsession() {
            this.studentitems = null;
            this.termitems = null;
            this.optionitems = null;
            this.Sessionitems = null;
            this.SessionIdval = 0;
            this.onloader = "flex";
            this.$store
                .dispatch("getregsession")
                .then((resp) => {
                    this.Sessionitems = resp;
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    console.log(err);
                });
        },
        getregterm() {
            this.classitems = null;
            this.studentitems = null;
            this.termitems = null;
            this.optionitems = null;
            this.report = null;
            this.TermIdval = 0;
            let SessionId = this.SessionIdval;
            if (SessionId > 0) {
                this.onloader = "flex";
                this.$store
                    .dispatch("getregterm", SessionId)
                    .then((resp) => {
                        this.termitems = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        console.log(err);
                    });
            }
        },
        getclass() {
            this.classitems = null;
            this.studentitems = null;
            this.optionitems = null;
            this.ClassIdval = 0;
            this.report = null;
            if (this.TermIdval > 0) {
                this.onloader = "flex";
                this.$store
                    .dispatch("getclass")
                    .then((resp) => {
                        this.classitems = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        console.log(err);
                    });
            }
        },
        getoption(event) {
            this.studentitems = null;
            this.optionitems = null;
            this.report = null;
            this.OptionIdval = 0;
            let ClassId = event.target.value;
            if (ClassId > 0) {
                this.onloader = "flex";
                this.$store
                    .dispatch("getoption", ClassId)
                    .then((resp) => {
                        this.optionitems = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        console.log(err);
                    });
            }
        },
        frontEndDateFormat(date) {
            return moment(date).format("YYYY-MM-DD");
        },
        backEndDateFormat(date) {
            return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
        },
    },
    mounted() {
        const userDetails = this.accessDetails = this.$store.getters['auth/_user'];
        if (
            userDetails.isSchoolStaff == false
        ) {
            this.$store.dispatch("auth/Logout");
            this.$router.push("/login");
        } else {
            this.getregsession();
            this.getcurendate();
        }

    },
};
</script>

<style>
.borderall {
    text-align: center;
    border: 3px solid #000;
}

.bordercol {
    text-align: center;
    padding-left: 5px;
    padding-right: 5px;
    border: thin solid #000;
}

.padbody {
    padding: 20px;
}

.padhead {
    padding: 5px;
    border: 3px solid #606060;
}

.pad {
    padding: 10px;
}

table {
    font-size: 9pt;
    width: 100%;
}

.bodytext {
    font-size: 9pt;
}
</style>
